import React, { useState, useEffect, useRef, useCallback} from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Toast } from "primereact/toast";
import { PiCourtBasketball } from "react-icons/pi";
import { LuSquareMenu } from "react-icons/lu";
import axios from "axios";
import "../SlotBooking/SlotBooking.css";
import DeletePopup from "../Components/DeletePopup";
import SlotManagement from "../../Admin/SlotBooking/SlotManagement";
import {
  deleteRerveredslot,
  getReservedslot,
  updateReservation,
} from "../../Services/BackendUrl";
import { FaCheck } from "react-icons/fa";
import { GrClose } from "react-icons/gr";
import { encryptedAuth } from "../../Services/EncryptData";

const forceBypassCache = (url) => {
  if (!url) return "";
  return `${url}?t=${new Date().getTime()}`;
};

const SlotBooking = ({ setIsExporting, showCustomerData, setShowCustomerData }) => {
  const toast = useRef(null);
  const lastFetchedTab = useRef(null);
  const [activeTab, setActiveTab] = useState("booking");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editedBooking, setEditedBooking] = useState({});
  const [showCheckboxes, setShowCheckboxes] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [slotData, setSlotData] = useState([]);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [pendingDeleteRow, setPendingDeleteRow] = useState(null);
  const [pendingMultipleDelete, setPendingMultipleDelete] = useState(false);
  const [file, setFile] = useState();
    const types = [
        { name: 'Weekly Slot Booking (Excluding Friday & Saturday)', code: 'WEEKLY_EXCL_FRI_SAT' },
        { name: 'Weekly Slot Booking (Excluding Thursday & Friday)', code: 'WEEKLY_EXCL_THU_FRI' },
        { name: 'Weekly Slot Booking (7 DAYS)', code: 'WEEKLY_7_DAYS'},
        { name: 'Weekly Slot Booking (6 days Excl Friday)', code: 'WEEKLY_6_EXCL_FRI' },
        { name: 'Weekly Slot Booking (6 days Excl Thursday)', code: 'WEEKLY_6_EXCL_THU' },
        { name: 'Weekly Slot Booking (6 days Excl Saturday)', code: 'WEEKLY_6_EXCL_SAT' },
        { name: 'Weekened SLOT-1 (Friday & Saturday)', code: 'WEEKEND_SLOT1_FRI_SAT' },
        { name: 'Weekened SLOT-2 (Thursday & Friday)', code: 'WEEKEND_SLOT2_THU_FRI' },
        { name: 'Weekened SLOT-3 (Thursday & Saturday)', code: 'WEEKEND_SLOT3_THU_SAT' },
        { name: 'Weekened SLOT-4 (Thursday only)', code: 'WEEKEND_SLOT4_THU' },
        { name: 'Weekened SLOT-5 (Friday only)', code: 'WEEKEND_SLOT5_FRI' },
        { name: 'Weekened SLOT-6 (Saturday only)', code: 'WEEKEND_SLOT6_SAT' },
        { name: 'Coaching KIDS(7 Days)', code: 'COACHING_KIDS_7DAY' },
        { name: 'Coaching Adults(7 Days)', code: 'COACHING_ADULTS_7DAY' },
    ];

  const fetchAllSlots = useCallback(async () => {
    try {
      const response = await axios.get(getReservedslot, {
        headers: { "Content-Type": "application/json",
        Authorization : `Encrypted ${encryptedAuth}`}
      });

      const formatted = response.data.bookings.map((c, i) => ({
        ...c,
        id: (i + 1).toString().padStart(2, "0"),
        checkbox: false,
        isChecked: false,
        slot: `${c.from} - ${c.to}`,
        court: ` ${c.courtNo}`,
      }));
      setSlotData(formatted);
    } catch (error) {
      console.error("Error fetch slots:",error);
    } finally {
      setIsExporting(false);
    }
  }, [setIsExporting]);

  useEffect(() => {
    if (activeTab !== "booking") {
      lastFetchedTab.current = activeTab;
      return;
    }
    if (lastFetchedTab.current === "booking") return;
    lastFetchedTab.current = "booking";
    fetchAllSlots();
  }, [activeTab, fetchAllSlots]);

  const handleFileUpload = (e) => {
    const uploadedFile = e.target.files[0];
    if (!uploadedFile) return;
    setFile(uploadedFile);
    setEditedBooking((prev) => ({
      ...prev,
      receipt: { filename: uploadedFile.name },
    }));
  };

  
  const handleDeleteReservations = async (rowData = null) => {
    let reservationIds = rowData
      ? [rowData.reservationId]
      : slotData
          .filter((row) => selectedRows.includes(row.id))
          .map((row) => row.reservationId);

    if (reservationIds.length === 0) {
      setShowCheckboxes(false);
      setSelectedRows([]);
      return;
    }

    try {
      await axios.post(
        deleteRerveredslot,
        { reservationIds },
        {
          headers: { "Content-Type": "application/json",
          Authorization : `Encrypted ${encryptedAuth}`
         },
        }
      );

      const remaining = slotData.filter(
        (c) => !reservationIds.includes(c.reservationId)
      );
      const reindexed = remaining.map((c, i) => ({
        ...c,
        id: (i + 1).toString().padStart(2, "0"),
        checkbox: false,
        isChecked: false,
      }));

      setSlotData(reindexed);
      setSelectedRows([]);
      setShowCheckboxes(false);
      toast.current.show({
        severity: "custom",
        life: 4000,
        content: (
          <div
            style={{
              backgroundColor: "#63F52066",
              width: "100%",
              padding: "20px",
              display: "flex",
              justifyContent: "flex-start",
              gap: "20px",
              alignItems: "center",
              color: "white",
              borderRadius: "6px",
            }}
          >
            <FaCheck size={24} />
            <span className="font-medium">
              Reservation Deleted Successfully.
            </span>
          </div>
        ),
      });
    } catch (error) {
      toast.current.show({
        severity: "custom",
        life: 4000,
        content: (
          <div
            style={{
              backgroundColor: "#FF7F5077",
              width: "100%",
              padding: "20px",
              display: "flex",
              justifyContent: "flex-start",
              gap: "12px",
              alignItems: "center",
              color: "white",
              borderRadius: "6px",
            }}
          >
            <GrClose size={20} className="text-white" />
            <span className="font-medium">Failed to delete Reservation.</span>
          </div>
        ),
      });
    }
  };

  const triggerDeleteConfirmation = (rowData = null) => {
    if (rowData) {
      setPendingDeleteRow(rowData);
      setPendingMultipleDelete(false);
    } else {
      setPendingDeleteRow(null);
      setPendingMultipleDelete(true);
    }
    setShowDeletePopup(true);
  };

  const confirmDelete = () => {
    if (pendingMultipleDelete) {
      handleDeleteReservations();
    } else {
      handleDeleteReservations(pendingDeleteRow);
    }

    const updated = slotData.map((c) => ({
      ...c,
      checkbox: false,
      isChecked: false,
    }));
    setSlotData(updated);
    setShowCheckboxes(false);
    setSelectedRows([]);
    setShowDeletePopup(false);
  };

  const handleSaveEdit = async (e) => {
    e.preventDefault();

    const requiredFields = ["name", "fromDate", "slot", "court", "players"];
    for (const field of requiredFields) {
      if (!editedBooking[field]) return;
    }

    let from = "",
      to = "";
    if (
      typeof editedBooking.slot === "string" &&
      editedBooking.slot.includes("-")
    ) {
      [from, to] = editedBooking.slot.split("-").map((str) => str.trim());
    }

    if (!from || !to) return;

    const courtNo = editedBooking.court?.replace("Court", "").trim();
    const formData = new FormData();
    try {
      const updatedData = {
        reservationId: editedBooking.reservationId,
        name: editedBooking.name,
        fromDate:editedBooking.fromDate,
        toDate: editedBooking.toDate || null,
        from,
        to,
        courtNo,
        players: Number(editedBooking.players),
        phone: editedBooking.phone || "",
        email: editedBooking.email || "",
        price: editedBooking.price || 0,
        status: editedBooking.status || "booked",
        file: "",
        bookedOn: editedBooking.bookedOn || new Date().toISOString(),
        updatedOn: new Date().toISOString(),
        bookingType: editedBooking.bookingType || ""
      }; 
      formData.append("file", file);
      formData.append("body", JSON.stringify(updatedData));

      const response = await axios.put(updateReservation, formData, {
        headers: { "Content-Type": "multipart/form-data",
        Authorization : `Encrypted ${encryptedAuth}`
      },
      });
      const updatedReservation = {
        ...response.data.reservation,
        updatedOn: updatedData.updatedOn,
      };
      const updatedList = slotData.map((item) =>
        item.reservationId === updatedReservation.reservationId
          ? {
              ...item,
              ...updatedReservation,
              id: item.id,
              slot: `${updatedReservation.from} - ${updatedReservation.to}`,
              court: `${updatedReservation.courtNo}`,
            }
          : item
      );

      setSlotData(updatedList);
      setIsEditMode(false);
      setEditedBooking({});
      setSelectedBooking(null);
      fetchAllSlots();
      toast.current.show({
        severity: "custom",
        life: 3000,
        content: (
          <div
            style={{
              backgroundColor: "#63F52066",
              width: "100%",
              padding: "20px",
              display: "flex",
              justifyContent: "flex-start",
              gap: "12px",
              alignItems: "center",
              color: "white",
              borderRadius: "6px",
            }}
          >
            <FaCheck size={24} className="text-white" />
            <span className="font-medium">Booking updated successfully!</span>
          </div>
        ),
      });
    } catch (error) {
      toast.current.show({
        severity: "custom",
        life: 4000,
        content: (
          <div
            style={{
              backgroundColor: "#FF7F5077",
              width: "100%",
              padding: "20px",
              display: "flex",
              justifyContent: "flex-start",
              gap: "12px",
              alignItems: "center",
              color: "white",
              borderRadius: "6px",
            }}
          >
            <GrClose size={20} className="text-white" />
            <span className="font-medium">Edited details not Submitted.</span>
          </div>
        ),
      });
    }
  };

  const checkboxBodyTemplate = (rowData) => {
    if (!rowData.checkbox) return null;
    const isChecked = selectedRows.includes(rowData.id);

        return (
            <Checkbox
                inputId={`cb_${rowData.id}`}
                className=""
                checked={isChecked}
                onChange={(e) => {
                    const checked = e.checked;

          setSelectedRows((prev) =>
            checked
              ? [...prev, rowData.id]
              : prev.filter((id) => id !== rowData.id)
          );

          const updated = slotData.map((c) =>
            c.id === rowData.id ? { ...c, isChecked: checked } : c
          );
          setSlotData(updated);
        }}
      />
    );
  };

  const handleChange = (field, value) => {
    setEditedBooking({ ...editedBooking, [field]: value });
  };

  const actionTemplate = (rowData) => (
    <div className="flex gap-3 justify-center">
      <Button
        icon="pi pi-eye"
        className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#2d4a5e] hover:scale-105 transition text-cyan-400 border-none"
        onClick={() => {
    setSelectedBooking(rowData); 
    setIsEditMode(false);        
    setEditedBooking({});
    setShowCustomerData(true); 
  }}
      />

      <Button
        icon="pi pi-trash"
        className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#2d4a5e] hover:scale-105 transition text-red-400 border-none"
        onClick={() => triggerDeleteConfirmation(rowData)}
      />

      <Button
        icon="pi pi-file-edit"
        className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#2d4a5e] hover:scale-105 transition text-yellow-400 border-none"
        onClick={() => {
          setSelectedBooking(rowData);
          setIsEditMode(true);
          setEditedBooking(rowData);
          setShowCustomerData(true)
        }}
      />
    </div>
  );

  const renderTable = (data) => (
    <div className="p-4 bg-[linear-gradient(to_right,#2b8bff10,#7fc5ff40)] rounded-xl custom-table">
      <DataTable
        value={data}
        scrollable
        scrollHeight="470px"
        paginator
        rows={5}
        paginatorTemplate={{
          layout: "PrevPageLink PageLinks NextPageLink ",
          PrevPageLink: (options) => {
            return (
              <button
                type="button"
                onClick={options.onClick}
                disabled={options.disabled}
                className="px-4 py-2 border-white rounded-md text-white bg-transparent hover:bg-[#1f2a37] transition"
              >
                <div className="flex gap-2">
                  <i className="pi pi-angle-left"></i>
                  <p>Back</p>
                </div>
              </button>
            );
          },
          NextPageLink: (options) => {
            return (
              <button
                type="button"
                onClick={options.onClick}
                disabled={options.disabled}
                className="px-4 py-2 border-white rounded-md text-white bg-transparent hover:bg-[#1f2a37] transition"
              >
                <div className="flex gap-2">
                  <p>Next</p>
                  <i className="pi pi-angle-right "></i>
                </div>
              </button>
            );
          },
        }}
        className=" text-white font-lufga"
        tableStyle={{ minWidth: "50rem" }}
      >
        <Column
          header="S.No"
          headerStyle={{
            color: "white",
            paddingLeft: "1.3rem",
            border: "none",
            borderTopLeftRadius: "20px",
            borderBottomLeftRadius: "20px",
          }}
          bodyStyle={{
            color: "#d1d5db",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "center",
          }}
          body={(rowData, { rowIndex }) =>
            String(rowIndex + 1).padStart(2, "0")
          }
        />

        <Column
  header="Date"
  body={(rowData) => {
    const formatDate = (date) => {
      if (!date) return "-";
      const d = new Date(date);
      return d.toLocaleDateString("en-GB"); 
    };
    const from = formatDate(rowData.fromDate);
    const to = rowData.toDate ? ` - ${formatDate(rowData.toDate)}` : "";
    return `${from}${to}`;
  }}
  headerStyle={{
    background: "#7FC5FF26",
    color: "white",
    paddingLeft: "4rem",
    border: "none",
  }}
  bodyStyle={{
    color: "#d1d5db",
    textAlign: "center",
  }}
/>


        <Column
          field="slot"
          header="Time Slot"
          headerStyle={{
            background: "#7FC5FF26",
            color: "white",
            paddingLeft: "4rem",
            border: "none",
          }}
          bodyStyle={{
            color: "#d1d5db",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "center",
          }}
        />
        <Column
          field="courtNo"
          header="Court"
          headerStyle={{
            background: "#7FC5FF26",
            color: "white",
            paddingLeft: "1rem",
            border: "none",
          }}
          bodyStyle={{
            color: "#d1d5db",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "center",
          }}
        />
        <Column
          field="name"
          header="Name"
          style={{ minWidth: "120px", maxWidth: "120px" }}
          headerStyle={{
            background: "#7FC5FF26",
            color: "white",
            paddingLeft: "2rem",
            border: "none",
          }}
          bodyStyle={{
            color: "#d1d5db",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "center",
          }}
        />
        <Column
          field="players"
          header="Player Count"
          headerStyle={{
            background: "#7FC5FF26",
            color: "white",
            border: "none",
          }}
          bodyStyle={{
            color: "#d1d5db",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "center",
          }}
        />
        <Column
          header="Actions"
          body={actionTemplate}
          headerStyle={{
            background: "#7FC5FF26",
            color: "white",
            paddingLeft: "4rem",
            border: "none",
          }}
          bodyStyle={{
            color: "#d1d5db",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "center",
          }}
        />
        <Column
          header={
            <Button
              className="mr-5 border-none bg-transparent"
              icon={
                showCheckboxes
                  ? "pi pi-trash text-red-600"
                  : "pi pi-pencil text-white"
              }
              onClick={() => {
                if (showCheckboxes) {
                  const anyChecked = slotData.some((c) => c.isChecked);
                  if (anyChecked) {
                    triggerDeleteConfirmation();
                  } else {
                    setShowCheckboxes(false);
                    const updated = slotData.map((c) => ({
                      ...c,
                      checkbox: false,
                      isChecked: false,
                    }));
                    setSlotData(updated);
                    setSelectedRows([]);
                  }
                } else {
                  const updated = slotData.map((c) => ({
                    ...c,
                    checkbox: true,
                  }));
                  setSlotData(updated);
                  setShowCheckboxes(true);
                }
              }}
            />
          }
          body={checkboxBodyTemplate}
          headerStyle={{
            color: "white",
            border: "none",
            borderTopRightRadius: "20px",
            borderBottomRightRadius: "20px",
          }}
          bodyStyle={{
            color: "#d1d5db",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "center",
          }}
        />
      </DataTable>
    </div>
  );
  const renderDetailView = (booking) => {
    const editable = isEditMode;
    const bookingData = editable ? editedBooking : booking;

    function formatDateForInput(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      return date.toISOString().split("T")[0];
    }
    function formatDateOnly(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      if (isNaN(date)) return dateString;
      return date.toLocaleDateString("en-GB");
    }

    const getBookingTypeCode = (value) => {
      if (!value || value === "-") return "";
      const direct = types.find((t) => t.code === value);
      if (direct) return direct.code;
      const byName = types.find((t) => t.name === value);
      return byName ? byName.code : value;
    };

    const getBookingTypeLabel = (value) => {
      if (!value || value === "-") return "";
      const match = types.find((t) => t.code === value || t.name === value);
      return match ? match.name : value;
    };

    const displayOrDash = (value) =>
      value === null || value === undefined || value === "" ? "-" : value;

    return (
      <div className="p-4 sm:p-6 bg-[#0E1A2B] text-white rounded-xl min-h-[400px] flex flex-col gap-6 w-full max-w-[95vw] md:max-w-5xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
          <h2 className="text-lg sm:text-xl font-bold">BOOKING DETAILS</h2>
          {!editable && (
  <button
    onClick={() => {
      setIsEditMode(true);
      setEditedBooking(booking);
    }}
    className="flex items-center gap-2 px-4 py-2 bg-[#1E3A5F] border-none text-white rounded-full shadow hover:bg-[#2D4A5E] transition"
  >
    <span className="font-lufga font-[16px]">Edit</span>
    <span className="flex items-center justify-center w-8 h-8 border-none rounded-full bg-[#2D4A5E]">
      <i className="pi pi-file-edit text-white text-sm"></i>
    </span>
  </button>
)}

        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {[
            "reservationId",
            "name",
            "fromDate",
            "toDate",
            "slot",
            "court",
            "phone",
            "email",
            "players",
            // "bookedOn",
            "price",
            // "updatedOn",
            "receipt",
            "bookingType"
          ].map((field) => (
            <div key={field}>
              <strong className="text-[#0BB1E9]">
                {field.charAt(0).toUpperCase() + field.slice(1)}
              </strong>

              <br />

              {editable ? (
                field === "receipt" ? (
                  <div className="flex flex-col md:flex-row gap-3 mt-4">
                    <div>
                      <input
                        type="file"
                        id="file-upload"
                        onChange={handleFileUpload}
                        className="hidden"
                      />
                      <label htmlFor="file-upload" className="cursor-pointer">
                        <div className="w-8 h-8 flex items-center justify-center rounded-full border border-white text-white text-xl hover:bg-white hover:text-black transition">
                          +
                        </div>
                      </label>
                    </div>
                    <div
                      title={file ? file.name : bookingData.receipt?.filename}
                      onClick={() => {
                        if (!file && bookingData.receipt?.url) {
                          window.open(
                            forceBypassCache(bookingData.receipt.url),
                            "_blank"
                          );
                        }
                      }}
                      className="bg-[#258EC8] cursor-pointer rounded-lg px-4 py-2 text-white text-sm flex items-center gap-2 min-w-[140px] overflow-hidden"
                    >
                      <i className="pi pi-file" />
                      {file
                        ? file.name.length > 15
                          ? "..." + file.name.slice(-15)
                          : file.name
                        : bookingData.receipt?.filename?.length > 15
                        ? "..." + bookingData.receipt.filename.slice(-15)
                        : bookingData.receipt?.filename || "No file selected"}
                    </div>
                  </div>
                ) : field === "bookingType" ? (
                  <select
                    value={getBookingTypeCode(bookingData.bookingType)}
                    onChange={(e) => handleChange(field, e.target.value)}
                    className="w-full px-3 py-2 bg-[#1f2a3d] border-[2px] border-white rounded-xl text-white mt-2 text-sm"
                    name={field}
                  >
                    <option value="" disabled>
                      Select booking type
                    </option>
                    {types.map((t) => (
                      <option key={t.code} value={t.code}>
                        {t.name}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    type={
                      ["fromDate", "toDate", "bookedOn", "updatedOn"].includes(
                        field
                      )
                        ? "date"
                        : ["players", "courtNo", "price"].includes(field)
                        ? "number"
                        : "text"
                    }
                    value={
                      ["fromDate", "toDate", "bookedOn", "updatedOn"].includes(
                        field
                      )
                        ? formatDateForInput(bookingData[field])
                        : bookingData[field] || ""
                    }
                    onChange={(e) => handleChange(field, e.target.value)}
                    className="w-full px-3 py-2 bg-[#1f2a3d] border-[2px] border-white rounded-xl text-white mt-2 text-sm"
                    name={field}
                  />
                )
              ) : field === "receipt" ? (
                booking[field]?.url ? (
                  <a
                    href={forceBypassCache(booking[field].url)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-400 underline break-all inline-block mt-2 text-sm"
                  >
                    View File
                  </a>
                ) : (
                  <p className="mt-2 text-sm text-white">Not uploaded</p>
                )
              ) : (
                <p className="mt-2 text-sm text-white">
                  {["date", "bookedOn", "updatedOn", "fromDate", "toDate"].includes(field)
                    ? formatDateOnly(booking[field])
                    : field === "bookingType"
                    ? displayOrDash(getBookingTypeLabel(booking[field]))
                    : displayOrDash(booking[field])}
                </p>
              )}
            </div>
          ))}
        </div>

        {editable && (
          <div className="flex flex-col sm:flex-row justify-end gap-4 mt-8">
            <Button
              label="Cancel"
              className="p-button-secondary text-white border border-gray-400 bg-transparent px-6 py-2 rounded-xl"
              onClick={() => {
                setIsEditMode(false);
                setEditedBooking({});
              }}
            />
            <Button
              label="Submit"
              className="p-button-success bg-[#0BB1E9] text-white px-6 py-2 rounded-xl font-semibold"
              onClick={handleSaveEdit}
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0E1A2B] to-[#0E1A2B] text-white">
      <Toast ref={toast} />
      <main className="p-6">
        <div className="flex flex-col md:flex-row items-stretch md:items-center rounded-2xl  overflow-hidden mb-6 p-1 ">
          {[
            [
              "booking",
              <PiCourtBasketball className="w-9 h-9" />,
              "Slot Booking",
            ],
            [
              "management",
              <LuSquareMenu className="w-8 h-8" />,
              "Slot Management",
            ],
          ].map(([tab, Icon, label], index) => (
            <button
              key={tab}
              onClick={() => {
                setActiveTab(tab);
                setSelectedBooking(null);
                setShowCustomerData(false);
              }}
              className={`flex items-center justify-center gap-2 p-4 w-full transition-all relative border-none cursor-pointer text-[18px] font-lufga tracking-wide
        ${
          activeTab === tab
            ? "bg-[#7FC5FF26] text-white"
            : "bg-transparent text-gray-400"
        }
        ${
          index === 0
            ? "rounded-t-2xl md:rounded-l-full md:rounded-tr-none"
            : "rounded-b-2xl md:rounded-r-full md:rounded-tl-none"
        }`}
            >
              {Icon}
              <span className="font-semibold">{label}</span>

              {activeTab === tab && (
                <div
                  className={`absolute bg-[#0BB1E9] bottom-0 left-0 w-full  h-1 ${
                   index === 0 ? "left-0  right-0" : "left-0 right-0"
                  }`}
                />
              )}
            </button>
          ))}
        </div>

        {(showCustomerData && selectedBooking) ? (
          renderDetailView(selectedBooking)
        ) : activeTab === "booking" ? (
          renderTable(slotData)
        ) : (
          <SlotManagement />
        )}

        <DeletePopup
          visible={showDeletePopup}
          onHide={() => setShowDeletePopup(false)}
          onConfirm={confirmDelete}
        />
      </main>
    </div>
  );
};

export default SlotBooking;
